import React, { useEffect } from "react";
import Navbar from '../components/Navbar';
import SecondaryHero from "../components/SecondaryHero";
import InfoSection from '../components/InfoSection';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const MainContributors = () => {
  return (
    <div>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Main Contributors | VisionBird Technologies</title>
        <meta
          name="description"
          content="Meet the visionary leadership and talented team at VisionBird Technologies. Discover the professionals driving innovation and excellence."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        title="Our Main"
        titleLast=""
        highlight="Contributors"
        description="Meet our Main Contributors – including our visionary CEO and a team of talented professionals shaping our vision into reality. Their skills, passion, and teamwork make every project shine. Together, they drive innovation and excellence in everything we do."
        image="/assets/Images/Resume-pana 1.png"
      />
      <InfoSection />
      <Footer />
    </div>
  );
};

export default MainContributors;